import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "besidaMob-check.icon",
  "use": "besidaMob-check.icon-usage",
  "viewBox": "0 0 10 10",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 10 10\" id=\"besidaMob-check.icon\"><path d=\"M4.1 8.5L1.3 5.7c-.4-.4-.4-1 0-1.4s1-.4 1.4 0l1.2 1.2 3.3-4.1c.3-.4 1-.5 1.4-.2s.5 1 .2 1.4L4.1 8.5z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol